import { createReducer, on } from '@ngrx/store';
import { loadUser } from '@store/actions/user.actions';
import { User } from '@domain/types';
import { AccountType } from 'cve-auth';

export const initialState: User = {
    accountType: AccountType.PERSONAL,
    addressId: null,
    allVehiclesDeleted: false,
    appId: 'OREGO_RUC',
    appsFlyerId: '',
    companyName: '',
    email: '',
    firstTimeReady: false,
    hasTransponder: false,
    id: '',
    identityProvider: '',
    maxPaymentAttempts: 0,
    middleName: '',
    name: '',
    paymentAttempts: 0,
    paymentMethodRegistered: false,
    phoneNumber: null,
    privacyPolicyVersion: '',
    profileCompleted: false,
    registrationChannel: 'WEB',
    status: 'PENDING',
    surname: '',
    termsAndConditionsAccepted: false,
    termsAndConditionsVersion: '',
    userInfoReviewed: false,
    vehicleCreated: false,
};

export const userReducer = createReducer(
    initialState,
    on(loadUser, (_state, action) => {
        return {
            ...action.user,
        };
    })
);
